import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { SubNav } from '../layout/submenu';
import { CustomAccordionToggle } from '../crew/CustomAccordionToggle';

const GeoCard = props => {
    const { selected, item, showBulkEdit, areaShortName, isAllowEdit, isAllowDelete,
        isToday, isMapLoaded, onSelect, onClickEdit, onClickDelete, onClickFocus,
        onClickBulkEdit, onClickActivate, eventKey, expand } = props;
    const isFocusButton = item.active ? true : selected;

    return <SubNav.Item
        selected={selected}
        className="item-checkbox highlight geo-type">
        <SubNav.Card className={`${item.alive ? "" : "alive-default"}`}>
            <Row className="p-0 m-0">
                <Col lg={1} md={1} sm={1} className="p-0 m-0">
                    <span className={`p-0 m-0 ml-2 ${expand ? '' : 'hidden'}`}>
                        <CustomAccordionToggle eventKey={eventKey} />
                    </span>
                    <SubNav.Checkbox
                        className="mt-1"
                        checked={selected}
                        onChange={onSelect.bind(this, item.geo_region_uuid)}
                    />
                </Col>
                <Col lg={6} md={6} sm={6} className="p-0 m-0">
                    <SubNav.Name>
                        {item.geo_region_name}
                    </SubNav.Name>
                </Col>
                <Col lg={5} md={5} sm={5} className="p-0 m-0">
                    {isMapLoaded &&
                        <SubNav.ButtonGroup>
                            {isFocusButton && <i className="fa fa-binoculars mr-3" title="Focus" onClick={onClickFocus.bind(this, item)} />}
                            {showBulkEdit && item.alive && <i className="fa fa-sliders mr-3" title="Bulk edit" aria-hidden="true" onClick={onClickBulkEdit.bind(this, true)} />}
                            {isToday && item.alive && <>
                                {isAllowEdit && <SubNav.EditButton onClick={onClickEdit.bind(this, item)} />}
                                {isAllowDelete && <SubNav.DeleteButton onClick={onClickDelete.bind(this, { ...item, isRemoveButton: true })} />}
                            </>}
                            {!item.active && <>
                                <SubNav.ActivateButton onClick={onClickActivate.bind(this, item)} />
                                <SubNav.DeleteButton onClick={onClickDelete.bind(this, { ...item, isRemoveButton: false })} />
                            </>}
                        </SubNav.ButtonGroup>}
                </Col>
            </Row>
            <Row className="p-0 m-0 mb-1">
                <SubNav.Display1>
                    <div className="d-flex">
                        {areaShortName}:  {item.area}
                        {item.crop_name && <SubNav.Pipe />}
                        {item.crop_name}
                    </div>
                </SubNav.Display1>
            </Row>
            <Row className="p-0 m-0">
                <SubNav.DateRange
                    start={item.start_date}
                    end={item.end_date}
                    alive={item.alive}
                />
            </Row>
        </SubNav.Card>
    </SubNav.Item>;
};

export default GeoCard;